import { useEffect, useState } from "react";
import { baseUrl } from "../../connections";
import { appendAuthToken } from "../../utils/authSession";

export const useVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState("");
  const [payload, setOTPPayload] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (payload && Object.keys(payload).length > 0) {
      setIsLoading(true);
      setIsOTPVerified("");
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      appendAuthToken(headers);

      const body = JSON.stringify(payload);

      const requestOptions = {
        method: "PUT",
        headers: headers,
        body: body,
        redirect: "follow",
      };

      fetch(`${baseUrl}/user/verify/by/code`, requestOptions)
        .then(async (response) => {
          const res = await response.text();
          if (response.status !== 200) {
            throw res;
          }
          return JSON.parse(res);
        })
        .then((result) => {
          if (result.suucees) {
            setError(false);
            setMessage("Verified Successfully");
            setIsOTPVerified(true);
            setIsLoading(false);
          } else {
            setMessage("Something went wrong! Please try again later.");
          }
        })
        .catch((err) => {
          setMessage(err);
          setIsLoading(false);
          setError(true);
          setIsOTPVerified(false);
        });
    }
  }, [payload]);

  return {
    isOTPVerified,
    isLoading,
    error,
    message,
    setOTPPayload,
  };
};
